import React from 'react';
import { Form, Select, InputNumber } from 'antd';
import { useTranslation } from 'react-i18next';
import { AlarmMomentWeekOptions } from '@utils/alarmsConstants';
import {
  ResponsiveRadioGroup,
  StyledRadioButton,
  TimePickerStyled,
} from './styles';

export function AlarmSeasonalFields() {
  const { t } = useTranslation('create-alarm-step');

  const MomentWeekOptions = [
    {
      label: t('create-alarm-step:stepTwo.createAlarmSeasonalMomentWeekSunday'),
      value: AlarmMomentWeekOptions.SUNDAY,
    },
    {
      label: t('create-alarm-step:stepTwo.createAlarmSeasonalMomentWeekMonday'),
      value: AlarmMomentWeekOptions.MONDAY,
    },
    {
      label: t(
        'create-alarm-step:stepTwo.createAlarmSeasonalMomentWeekTuesday',
      ),
      value: AlarmMomentWeekOptions.TUESDAY,
    },
    {
      label: t(
        'create-alarm-step:stepTwo.createAlarmSeasonalMomentWeekWednesday',
      ),
      value: AlarmMomentWeekOptions.WEDNESDAY,
    },
    {
      label: t(
        'create-alarm-step:stepTwo.createAlarmSeasonalMomentWeekThursday',
      ),
      value: AlarmMomentWeekOptions.THURSDAY,
    },
    {
      label: t('create-alarm-step:stepTwo.createAlarmSeasonalMomentWeekFriday'),
      value: AlarmMomentWeekOptions.FRIDAY,
    },
    {
      label: t(
        'create-alarm-step:stepTwo.createAlarmSeasonalMomentWeekSaturday',
      ),
      value: AlarmMomentWeekOptions.SATURDAY,
    },
  ];

  return (
    <>
      <Form.Item
        name="seasonalMeasure"
        label={t('create-alarm-step:stepTwo.createAlarmSeasonalMeasureField')}
        rules={[
          {
            required: true,
            message: t(
              'create-alarm-step:stepTwo.createAlarmSeasonalMeasureFieldRequired',
            ),
          },
        ]}
      >
        <ResponsiveRadioGroup optionType="button">
          <StyledRadioButton value="perc_min_sazonal" position="left">
            {t(
              'create-alarm-step:stepTwo.createAlarmSeasonalMeasureBelowField',
            )}
          </StyledRadioButton>
          <StyledRadioButton value="perc_max_sazonal" position="right">
            {t(
              'create-alarm-step:stepTwo.createAlarmSeasonalMeasureAboveField',
            )}
          </StyledRadioButton>
        </ResponsiveRadioGroup>
      </Form.Item>

      <Form.Item
        name="seasonalMoment"
        label={t('create-alarm-step:stepTwo.createAlarmSeasonalMomentField')}
        rules={[
          {
            required: true,
            message: t(
              'create-alarm-step:stepTwo.createAlarmSeasonalMomentFieldRequired',
            ),
          },
        ]}
      >
        <Select
          allowClear
          options={MomentWeekOptions}
          style={{ textAlign: 'left' }}
        />
      </Form.Item>

      <Form.Item
        name="seasonalTime"
        label={t('create-alarm-step:stepTwo.createAlarmSeasonalTimeField')}
        rules={[
          {
            required: true,
            message: t(
              'create-alarm-step:stepTwo.createAlarmSeasonalTimeFieldRequired',
            ),
          },
        ]}
      >
        <TimePickerStyled
          style={{ width: '100%' }}
          minuteStep={5}
          showSecond={false}
          showNow={false}
          format="HH:mm"
          placeholder=""
        />
      </Form.Item>

      <Form.Item
        name="seasonalValue"
        label={t(
          'create-alarm-step:stepTwo.createAlarmSeasonalValueToTriggerField',
        )}
        rules={[
          {
            required: true,
            message: t(
              'create-alarm-step:stepTwo.createAlarmSeasonalValueToTriggerFieldRequired',
            ),
          },
        ]}
      >
        <InputNumber<number>
          min={0}
          max={100}
          step={0.1}
          formatter={value => `${value}%`}
          parser={value => {
            const cleaned = value?.replace('%', '').replace(',', '.') || '0';
            return parseFloat(cleaned);
          }}
          style={{ width: '100%' }}
        />
      </Form.Item>
    </>
  );
}
